'use strict';

var onEventsAccordionItemClicked = function onEventsAccordionItemClicked() {
  var accordion = document.querySelector('#events .accordion ul');

  if (!accordion) {
    return;
  }

  var accordionItems = accordion.querySelectorAll('li');

  accordionItems.forEach(function (item) {
    item.addEventListener('click', function () {
      accordion.classList.add('focused');
      accordionItems.forEach(function (item) {
        return item.classList.remove('opened');
      });
      item.classList.add('opened');
    });
  });
};

document.getElementById('events') && onEventsAccordionItemClicked();


//////////////////
// WEBPACK FOOTER
// ./js/homepage/events-accordion.js
// module id = ./js/homepage/events-accordion.js
// module chunks = 0